const BACKEND_URL = 'https://livingbytes-shopify-app.gadget.app';
const BACKEND_API_KEY = 'gsk-UW3yUGZ6XR8TqybrHVjVBazmEZnqQr32';
const SAVIVA_AUTH_URL = `https://prd-integrale.auth.eu-central-1.amazoncognito.com/oauth2/authorize?client_id=tnh1nuljb1lm3v7jmln0778v6&redirect_uri=${BACKEND_URL}/integrale/callback&response_type=code`;
const LOCALE = "";
const EXTERNAL_ID_LABEL = LOCALE === "fr" ? "Identifiant Client" : "Kundennummer";

// Helper function to show notifications
function showNotification({ type = "error", title = "", message = "", duration = 5000 }) {
  if (window.profileNotification) {
    window.profileNotification.show({ type, title, message, duration });
  } else {
    // Fallback to alert if notification system isn't loaded
    alert(message);
  }
}

// Check if CUSTOMER_ID already exists globally and has a valid value
if (typeof window.CUSTOMER_ID === "undefined") {
  window.CUSTOMER_ID = null;
}

if (
  !window.CUSTOMER_ID ||
  window.CUSTOMER_ID === "null" ||
  window.CUSTOMER_ID === "" ||
  window.CUSTOMER_ID === "undefined"
) {
  const CURRENT_CUSTOMER_ID = "";
  window.CUSTOMER_ID = CURRENT_CUSTOMER_ID;
}

// Create local reference for convenience
const CUSTOMER_ID = window.CUSTOMER_ID;

// SAVIVA_REDIRECT_URL is always set
const DEFAULT_MODAL_DATA = {
  variantId: "",
  customerId: CUSTOMER_ID,
  rewardId: "",
  points: "",
};

const QuickOrderListFeature = (() => {
  function init() {}

  return { init };
})();

// External Customer ID Modal Management
const ExternalCustomerIdModal = (() => {
  const i18n = {
    de: {
      title: "Kundennummer",
      description: "Bitte geben Sie Ihre Kundennummer für {partnerName} ein",
      continueBtn: "Weiter",
      profileLink: "Zum Profil",
      profileNote: "Sie können Ihre Kundennummer auch in den Profileinstellungen hinzufügen.",
    },
    fr: {
      title: "Identifiant Client",
      description: "Veuillez saisir votre identifiant client pour {partnerName}",
      continueBtn: "Continuer",
      profileLink: "Accédez à votre profil",
      profileNote: "Vous pouvez aussi ajouter votre identifiant client dans les paramètres de votre profil.",
    },
  };

  const currentI18n = i18n[LOCALE] || i18n.de;
  let pendingPartners = [];
  let currentPartnerIndex = 0;
  let dismissedThisSession = false;

  function init() {
    const modal = document.getElementById("external-customer-id-modal");
    if (!modal) return;

    const closeBtn = modal.querySelector(".external-customer-id-modal__close");
    const overlay = modal.querySelector(".external-customer-id-modal__overlay");
    const form = document.getElementById("external-customer-id-form");

    if (closeBtn) {
      closeBtn.addEventListener("click", () => hideModal());
    }

    if (overlay) {
      overlay.addEventListener("click", () => hideModal());
    }

    if (form) {
      form.addEventListener("submit", handleFormSubmit);
    }
  }

  function showModal(partners) {
    if (!Array.isArray(partners) || partners.length === 0) {
      console.log("[ExternalCustomerIdModal] No partners provided");
      return true;
    }

    if (
      partners.length === 1 &&
      (partners[0].handle.toLowerCase() === "mercanto" || partners[0].handle.toLowerCase() === "saviva")
    ) {
      console.log(`[ExternalCustomerIdModal] Skipping modal for single partner: ${partners[0].name}`);
      return true;
    }

    console.log("[ExternalCustomerIdModal] Opening modal with partners:", partners);

    pendingPartners = partners;
    currentPartnerIndex = 0;
    showNextPartnerForm();

    const modal = document.getElementById("external-customer-id-modal");
    if (modal) {
      console.log("[ExternalCustomerIdModal] Modal element found, showing...");
      modal.style.display = "flex";
    } else {
      console.error("[ExternalCustomerIdModal] Modal element not found!");
    }
  }

  function showNextPartnerForm() {
    if (currentPartnerIndex >= pendingPartners.length) {
      hideModal();
      return;
    }

    const partner = pendingPartners[currentPartnerIndex];
    const container = document.getElementById("customer-id-fields-container");
    const partnerNameSpan = document.getElementById("modal-partner-name");
    const submitBtn = document.querySelector(".external-customer-id-modal__submit");

    if (!container) return;

    container.innerHTML = "";
    if (partnerNameSpan) {
      partnerNameSpan.textContent = partner.name;
    }

    // Handle single or multiple partners
    if (pendingPartners.length === 1) {
      // Single partner - show one field
      container.innerHTML = `
        <div class="customer-id-field">
          <label for="customer-id-${partner.handle}">
            ${EXTERNAL_ID_LABEL}: ${partner.name}
          </label>
          <input
            type="text"
            id="customer-id-${partner.handle}"
            name="customer-id-${partner.handle}"
            data-handle="${partner.handle}"
            data-partner-name="${partner.name}"
            placeholder="z.B. ABC-123456"
            required
            autofocus
          />
        </div>
      `;
    } else {
      // Multiple partners - show all at once
      container.innerHTML = pendingPartners
        .map(
          (p) => `
        <div class="customer-id-field">
          <label for="customer-id-${p.handle}">
            ${EXTERNAL_ID_LABEL}: ${p.name}
          </label>
          <input
            type="text"
            id="customer-id-${p.handle}"
            name="customer-id-${p.handle}"
            data-handle="${p.handle}"
            data-partner-name="${p.name}"
            placeholder="z.B. ABC-123456"
            required
          />
        </div>
      `
        )
        .join("");
    }

    // Update button text based on context
    if (submitBtn) {
      if (pendingPartners.length === 1) {
        submitBtn.textContent = currentI18n.continueBtn;
      } else {
        submitBtn.textContent = currentI18n.continueBtn;
      }
    }
  }

  async function handleFormSubmit(event) {
    event.preventDefault();

    const inputs = document.querySelectorAll("#customer-id-fields-container input[required]");
    const customerIds = {};
    let isValid = true;

    inputs.forEach((input) => {
      if (!input.value.trim()) {
        isValid = false;
        input.style.borderColor = "#ff6b6b";
      } else {
        customerIds[input.dataset.handle] = input.value.trim();
        input.style.borderColor = "";
      }
    });

    if (!isValid) {
      showNotification({
        type: "error",
        title: LOCALE === "fr" ? "Erreur de validation" : "Validierungsfehler",
        message: LOCALE === "fr" ? "Veuillez remplir tous les champs" : "Bitte füllen Sie alle Felder aus",
        duration: 3000,
      });
      return;
    }

    const submitBtn = event.target.querySelector("button[type='submit']");
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-busy", "true");
    }

    try {
      await saveExternalCustomerIds(customerIds);

      if (pendingPartners.length === 1) {
        currentPartnerIndex++;
        if (currentPartnerIndex < pendingPartners.length) {
          showNextPartnerForm();
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.setAttribute("aria-busy", "false");
          }
        } else {
          hideModal();
          window.location.reload();
        }
      } else {
        hideModal();
        window.location.reload();
      }
    } catch (error) {
      console.error("[ExternalCustomerIdModal] Error saving customer IDs:", error);
      showNotification({
        type: "error",
        title: LOCALE === "fr" ? "Erreur" : "Fehler",
        message:
          LOCALE === "fr"
            ? "Une erreur est survenue. Veuillez réessayer."
            : "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        duration: 0,
      });

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.setAttribute("aria-busy", "false");
      }
    }
  }

  function getExistingExternalCustomerIds() {
    try {
      const hiddenInput = document.getElementById("Profile-ExternalPartnerIds");
      const existingData = hiddenInput && hiddenInput.value;

      if (existingData && existingData.trim() !== "") {
        const parsed = JSON.parse(existingData);
        return Array.isArray(parsed) ? parsed : [];
      }

      const externalIdsJson = localStorage.getItem("externalCustomerIds");
      if (externalIdsJson && externalIdsJson !== "null" && externalIdsJson !== '""') {
        const parsed = JSON.parse(externalIdsJson);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (error) {
      console.warn("[ExternalCustomerIdModal] Failed to read existing external customer IDs:", error);
    }

    return [];
  }

  async function saveExternalCustomerIds(customerIds) {
    const existingExternalIds = getExistingExternalCustomerIds();

    const updates = Object.entries(customerIds).map(([handle, id]) => {
      const partner = pendingPartners.find((p) => p.handle === handle);
      return {
        tradePartnerId: handle,
        partnerName: partner?.name || handle,
        externalCustomerId: id,
      };
    });

    const mergedExternalIds = [...existingExternalIds];
    updates.forEach((updatedItem) => {
      const existingIndex = mergedExternalIds.findIndex(
        (item) =>
          item.tradePartnerId === updatedItem.tradePartnerId ||
          (item.partnerName && updatedItem.partnerName && item.partnerName === updatedItem.partnerName)
      );

      if (existingIndex >= 0) {
        mergedExternalIds[existingIndex] = {
          ...mergedExternalIds[existingIndex],
          ...updatedItem,
        };
      } else {
        mergedExternalIds.push(updatedItem);
      }
    });

    const response = await fetch(`${BACKEND_URL}/customerUpdate`, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId: CUSTOMER_ID,
        externalCustomerIds: mergedExternalIds,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();
    if (data.status === "error") {
      throw new Error(data.message || "Unknown error");
    }

    localStorage.setItem("externalCustomerIds", JSON.stringify(mergedExternalIds));
    const hiddenInput = document.getElementById("Profile-ExternalPartnerIds");
    if (hiddenInput) {
      hiddenInput.value = JSON.stringify(mergedExternalIds);
    }

    return data;
  }

  function hideModal() {
    const modal = document.getElementById("external-customer-id-modal");
    if (modal) {
      modal.style.display = "none";
    }
    pendingPartners = [];
    currentPartnerIndex = 0;
    dismissedThisSession = true;
  }

  window.showExternalCustomerIdModal = showModal;
  window.hideExternalCustomerIdModal = hideModal;
  window.isExternalCustomerIdModalAutoDismissed = () => dismissedThisSession;
  window._resetExternalCustomerIdModalDismiss = () => { dismissedThisSession = false; };

  return {
    init,
    showModal,
    hideModal,
  };
})();

// Global Mercanto Token Management
const MERCANTO_STORAGE = {
  TOKEN: "mercantoToken",
  REFRESH: "mercantoRefreshToken",
  EXPIRES_AT: "mercantoTokenExpiresAt",
};
const MERCANTO_EXPIRY_BUFFER_MS = 60 * 1000;

function isMercantoSelected() {
  const handle = localStorage.getItem("selectedTradePartnerHandle");
  const partner = localStorage.getItem("selectedTradePartner");
  return handle === "mercanto" || partner === "mercanto";
}

function persistMercantoSession({ accessToken, refreshToken, expiresIn }) {
  if (accessToken) {
    localStorage.setItem(MERCANTO_STORAGE.TOKEN, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(MERCANTO_STORAGE.REFRESH, refreshToken);
  }

  const expiresInSeconds = Number(expiresIn);
  if (!Number.isNaN(expiresInSeconds) && expiresInSeconds > 0) {
    const expiresAt = Date.now() + expiresInSeconds * 1000;
    localStorage.setItem(MERCANTO_STORAGE.EXPIRES_AT, expiresAt.toString());
  }
}

function clearMercantoSession() {
  localStorage.removeItem(MERCANTO_STORAGE.TOKEN);
  localStorage.removeItem(MERCANTO_STORAGE.REFRESH);
  localStorage.removeItem(MERCANTO_STORAGE.EXPIRES_AT);
}

function shouldRefreshMercantoToken(expiresAt) {
  if (!expiresAt || Number.isNaN(expiresAt)) {
    return true;
  }
  return expiresAt - Date.now() <= MERCANTO_EXPIRY_BUFFER_MS;
}

async function refreshMercantoToken(refreshToken) {
  const response = await fetch(`${BACKEND_URL}/api/graphql`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      query:
        "mutation MercantoRefresh($refreshToken: String!) {\n mercanto {\n refresh(refreshToken: $refreshToken) {\n        success\n        result\n        errors {\n        message\n   }\n   }\n  } \n}",
      variables: {
        refreshToken: refreshToken,
      },
    }),
  });

  const data = await response.json();
  return data?.data?.mercanto?.refresh?.result?.data?.data?.attributes || null;
}

async function ensureValidMercantoToken() {
  try {
    if (!isMercantoSelected()) {
      console.log("[Mercanto] Not selected, skipping token refresh");
      return;
    }

    const token = localStorage.getItem(MERCANTO_STORAGE.TOKEN);
    const refreshToken = localStorage.getItem(MERCANTO_STORAGE.REFRESH);
    const expiresAt = Number(localStorage.getItem(MERCANTO_STORAGE.EXPIRES_AT));

    console.log("[Mercanto] Token validation check:", {
      hasToken: !!token,
      hasRefresh: !!refreshToken,
      expiresAt,
      shouldRefresh: shouldRefreshMercantoToken(expiresAt),
    });

    if (!token && !refreshToken) {
      console.log("[Mercanto] No tokens available");
      return;
    }

    if (!refreshToken) {
      console.warn("[Mercanto] No refresh token available, clearing session and deselecting merchant");
      clearMercantoSession();
      deselectMercantoTradePartner();
      return;
    }

    if (!shouldRefreshMercantoToken(expiresAt)) {
      console.log("[Mercanto] Token still valid");
      return;
    }

    console.log("[Mercanto] Refreshing access token");
    const refreshed = await refreshMercantoToken(refreshToken);
    if (!refreshed) {
      console.error("[Mercanto] Token refresh failed, clearing session and deselecting merchant");
      clearMercantoSession();
      deselectMercantoTradePartner();
      return;
    }

    console.log("[Mercanto] Token refreshed successfully");
    persistMercantoSession({
      accessToken: refreshed.accessToken,
      refreshToken: refreshed.refreshToken,
      expiresIn: refreshed.expiresIn,
    });
  } catch (error) {
    console.error("[Mercanto] Token refresh failed:", error);
    clearMercantoSession();
    deselectMercantoTradePartner();
  }
}

async function resetPartnerCartAndRedirect() {
  try {
    const cleared = await fetch("/cart/clear.js", { method: "POST" });
    localStorage.setItem("selectedTradePartner", "");
    localStorage.setItem("selectedTradePartnerHandle", "");
    window.location.href = "/";
  } catch (error) {
    console.error("[Mercanto] Error resetting partner cart and redirecting:", error);
  }
}

function deselectMercantoTradePartner() {
  localStorage.removeItem("selectedTradePartner");
  localStorage.removeItem("selectedTradePartnerHandle");
  localStorage.removeItem("checkoutType");

  // Reset all trade partner selects to default
  const tradePartnerSelections = document.querySelectorAll(".trade-partner-select");
  tradePartnerSelections.forEach((select) => {
    select.selectedIndex = 0;
  });

  // Disable product forms if the function is available
  if (typeof window.disableProductFormButtons === "function") {
    window.disableProductFormButtons();
  }

  console.log("[Mercanto] Trade partner deselected");
}

// Expose globally
window.ensureMercantoSession = ensureValidMercantoToken;
window.clearMercantoSession = clearMercantoSession;
window.deselectMercantoTradePartner = deselectMercantoTradePartner;

function showFullScreenSpinner(show = true, showText = true) {
  const spinnerId = "ufs-fullscreen-spinner";
  const existingSpinner = document.getElementById(spinnerId);

  if (show) {
    if (existingSpinner) {
      return;
    }

    const spinnerText =
      window.UFS_I18N && window.UFS_I18N.spinner_text ? window.UFS_I18N.spinner_text.replace(/\n/g, "<br>") : "";
    const spinnerHTML = `
      <div id="${spinnerId}" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center; z-index: 9999;">
        <div style="text-align: center;">
          <div style="width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #ff5a00; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
          <p style="color: #f3f3f3">${spinnerText}</p>
        </div>
      </div>
      <style id="${spinnerId}-styles">
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      </style>
    `;

    document.body.insertAdjacentHTML("beforeend", spinnerHTML);
  } else {
    if (existingSpinner) {
      existingSpinner.remove();
    }

    const spinnerStyles = document.getElementById(`${spinnerId}-styles`);
    if (spinnerStyles) {
      spinnerStyles.remove();
    }
  }
}

let isSavivaHandshakeRunning = false;

const SavivaFeature = (() => {
  console.log("[Saviva] Feature module initialized");
  const TOKEN_PARAM = "integraleToken";
  const PURCHASER_PARAM = "purchaserId";
  const STORAGE_KEYS = {
    token: "integraleToken",
    purchaser: "purchaserId",
  };

  function init() {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get(TOKEN_PARAM);
    const purchaserFromUrl = urlParams.get(PURCHASER_PARAM);

    if (tokenFromUrl) {
      persistSession(tokenFromUrl, purchaserFromUrl);
      console.log("[Saviva] Handshake triggered from URL token");
      startHandshake(tokenFromUrl);
    }
  }

  function persistSession(token, purchaserId) {
    localStorage.setItem(STORAGE_KEYS.token, token);
    if (purchaserId) {
      localStorage.setItem(STORAGE_KEYS.purchaser, purchaserId);
    }
  }

  function getSession() {
    return {
      token: localStorage.getItem(STORAGE_KEYS.token),
      purchaserId: localStorage.getItem(STORAGE_KEYS.purchaser),
    };
  }

  async function startHandshake(token) {
    isSavivaHandshakeRunning = true;
    showFullScreenSpinner(true, true);
    console.log("[Saviva] Handshake starting");

    try {
      const fetchSavivaPurchasersResponse = await fetchSavivaPurchasers(token);

      if (fetchSavivaPurchasersResponse) {
        console.log("[Saviva] Handshake successful, reloading without token");
        const purchasers =
          fetchSavivaPurchasersResponse?.data?.integrale?.fetchIntegralePurchasers?.result?.result?.purchasers;

        if (!purchasers || purchasers.length === 0) {
          showNotification({
            type: "error",
            title: "Verbindungsfehler",
            message: "Es gab ein Problem bei der Verbindung zu Saviva. Bitte versuchen Sie es erneut.",
            duration: 0,
          });
          removeParamAndReload(TOKEN_PARAM);
          return;
        }

        if (typeof window.showSavivaModal === "function") {
          window.showSavivaModal(purchasers);
          showFullScreenSpinner(false);
          return;
        } else {
          console.error("[Saviva] showSavivaModal is not available");
        }
      }

      console.warn("[Saviva] Handshake failed, redirecting to fallback");
      redirectToError();
    } catch (error) {
      console.error("Saviva handshake failed:", error);
      redirectToError();
    } finally {
      isSavivaHandshakeRunning = false;
    }
  }

  async function fetchSavivaPurchasers(token) {
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `mutation FetchIntegralePurchasers($accessToken: String!, $customerId: String!) {
          integrale {
            fetchIntegralePurchasers(accessToken: $accessToken, customerId: $customerId) {
              success
              result
              errors {
                message
              }
            }
          }
        }`,
        variables: {
          accessToken: token,
          customerId: CUSTOMER_ID,
        },
      }),
    });

    const res = await response.json();
    return res;
  }

  async function handleCheckout(event, button) {
    console.log("handleCheckout");
    const session = getSession();

    let selectedSupplierHandle = localStorage.getItem("selectedTradePartnerHandle");
    if (
      !selectedSupplierHandle ||
      selectedSupplierHandle === "null" ||
      selectedSupplierHandle === "" ||
      selectedSupplierHandle === "undefined"
    ) {
      selectedSupplierHandle = localStorage.getItem("selectedTradePartner");
    }
    const selectedCheckoutType = localStorage.getItem("checkoutType");

    if (selectedCheckoutType === "guest") {
      window.location.href = "/checkout";
      return;
    }

    switch (selectedSupplierHandle) {
      case "saviva":
      case "saviva---integrale":
        event.preventDefault();
        console.log("[Saviva] Checkout interception started");
        if (!CUSTOMER_ID || CUSTOMER_ID === "" || CUSTOMER_ID === "null") {
          window.location.href = "/account/login";
          return;
        }

        if (
          !confirm(
            (window.UFS_I18N && window.UFS_I18N.integrale_checkout_confirm) ||
              "Are you sure you want to proceed to the Saviva checkout?"
          )
        ) {
          return true;
        }

        showFullScreenSpinner(true, true);

        const checkoutFallbackTimeout = setTimeout(() => {
          console.warn("[Saviva] Checkout flow timed out, redirecting to re-auth");
          showFullScreenSpinner(false);
          showNotification({
            type: "error",
            title: "Checkout-Fehler",
            message: "Die Verbindung zu Saviva dauert zu lange. Sie werden zur Saviva-Anmeldung weitergeleitet.",
            duration: 3000,
          });
          const now = Date.now();
          sessionStorage.setItem("savivaRedirectTime", now.toString());
          window.location.href = SAVIVA_AUTH_URL;
        }, 15000);

        try {
          const lineItems = await fetchCartLineItems();
          const syncSavivaCartResponse = await syncSavivaCart(session, lineItems);
          console.log("[Saviva] Cart sync response:", JSON.stringify(syncSavivaCartResponse));

          const redirectUrl = syncSavivaCartResponse?.data?.integrale?.cart?.result?.data?.integrale?.redirectUrl;

          if (redirectUrl) {
            clearTimeout(checkoutFallbackTimeout);
            fetch("/cart/clear.js", { method: "POST" }).catch((error) => {
              console.warn("[Saviva] Failed to clear cart before redirect:", error);
            });
            console.log("[Saviva] Redirecting to:", redirectUrl);
            window.location.href = redirectUrl;
            return true;
          }

          console.warn("[Saviva] Missing redirect URL in response");
          clearTimeout(checkoutFallbackTimeout);
          showFullScreenSpinner(false);
          showNotification({
            type: "error",
            title: "Checkout-Fehler",
            message:
              "Es gab ein Problem bei der Weiterleitung zum Saviva Checkout. Sie werden zur Saviva-Anmeldung weitergeleitet.",
            duration: 3000,
          });
          setTimeout(() => {
            const now = Date.now();
            sessionStorage.setItem("savivaRedirectTime", now.toString());
            window.location.href = SAVIVA_AUTH_URL;
          }, 3000);
          return true;
        } catch (error) {
          clearTimeout(checkoutFallbackTimeout);
          console.error("Saviva checkout error:", error);
          showFullScreenSpinner(false);
          showNotification({
            type: "error",
            title: "Checkout-Fehler",
            message:
              "Es gab ein Problem bei der Weiterleitung zum Saviva Checkout. Sie werden zur Saviva-Anmeldung weitergeleitet.",
            duration: 3000,
          });
          setTimeout(() => {
            const now = Date.now();
            sessionStorage.setItem("savivaRedirectTime", now.toString());
            window.location.href = SAVIVA_AUTH_URL;
          }, 3000);
          return true;
        }
        break;
      case "mercanto":
        event.preventDefault();
        console.log("[Mercanto] Checkout interception started");
        if (!CUSTOMER_ID || CUSTOMER_ID === "" || CUSTOMER_ID === "null") {
          window.location.href = "/account/login";
          return;
        }
        // Confirm user wants to proceed to external Mercanto checkout
        if (
          !confirm(
            (window.UFS_I18N && window.UFS_I18N.mercanto_checkout_confirm) ||
              "Are you sure you want to proceed to the Mercanto checkout?"
          )
        ) {
          return true;
        }
        showFullScreenSpinner(true, true);
        const token = localStorage.getItem("mercantoToken");

        try {
          const lineItems = await fetchCartLineItems();
          const syncMercantoCartResponse = await syncMercantoCart(token, lineItems);
          console.log("[Mercanto] Cart sync response:", JSON.stringify(syncMercantoCartResponse));

          if (syncMercantoCartResponse?.data?.mercanto?.cart?.result?.data?.mercanto?.data?.attributes?.cartPageUrl) {
            const url = syncMercantoCartResponse.data.mercanto.cart.result.data.mercanto.data.attributes.cartPageUrl;
            console.log("[Mercanto] Redirecting to:", url);
            // Clear storefront cart before redirecting to external checkout
            await fetch("/cart/clear.js", { method: "POST" });
            window.location.href = url;
            return true;
          }

          console.warn("[Mercanto] Invalid or missing redirect URL in response");
          showFullScreenSpinner(false);
          showNotification({
            type: "error",
            title: "Checkout-Fehler",
            message:
              "Es gab ein Problem bei der Weiterleitung zum Mercanto Checkout. Sie werden zum regulären Checkout weitergeleitet.",
            duration: 3000,
          });
          setTimeout(() => {
            // resetPartnerCartAndRedirect();
            window.location.href = "/checkout";
          }, 3000);
          return true;
        } catch (error) {
          console.error("Mercanto checkout error:", error);
          showFullScreenSpinner(false);
          showNotification({
            type: "error",
            title: "Checkout-Fehler",
            message:
              "Es gab ein Problem bei der Weiterleitung zum Mercanto Checkout. Sie werden zum regulären Checkout weitergeleitet.",
            duration: 3000,
          });
          setTimeout(() => {
            // resetPartnerCartAndRedirect();
            window.location.href = "/checkout";
          }, 3000);
          return true;
        }

        break;
      default:
        return;
    }
  }

  async function syncMercantoCart(token, lineItems) {
    const refreshToken = localStorage.getItem("mercantoRefreshToken");
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `mutation CartMercanto($accessToken: String!, $refreshToken: String, $customerId: String, $purchaserId: String, $cart: String!) {
          mercanto {
            cart(accessToken: $accessToken, refreshToken: $refreshToken, customerId: $customerId, purchaserId: $purchaserId, cart: $cart) {
              result
              success
              errors {
                message
              }
            }
          }
        }`,
        variables: {
          accessToken: token,
          refreshToken: refreshToken,
          purchaserId: localStorage.getItem("purchaserId"),
          customerId: CUSTOMER_ID,
          cart: JSON.stringify(lineItems),
        },
      }),
    });

    const payload = await response.json();
    console.log("[Mercanto] Cart sync response", payload);

    // Update tokens if backend refreshed them
    const refreshedTokens = payload?.data?.mercanto?.cart?.result?.data?.refreshedTokens;
    if (refreshedTokens?.accessToken) {
      console.log("[Mercanto] Backend refreshed tokens during cart sync, updating localStorage");
      localStorage.setItem("mercantoToken", refreshedTokens.accessToken);
      if (refreshedTokens.refreshToken) {
        localStorage.setItem("mercantoRefreshToken", refreshedTokens.refreshToken);
      }
    }

    return payload;
  }

  async function syncSavivaCart(session, lineItems) {
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `mutation CartIntegrale($accessToken: String!, $customerId: String, $purchaserId: String, $cart: String!) {
          integrale {
            cart(accessToken: $accessToken, customerId: $customerId, purchaserId: $purchaserId, cart: $cart) {
              result
              success
              errors {
                message
              }
            }
          }
        }`,
        variables: {
          accessToken: session.token,
          purchaserId: session.purchaserId,
          customerId: CUSTOMER_ID,
          cart: JSON.stringify(lineItems),
        },
      }),
    });

    const payload = await response.json();
    console.log("[Saviva] Cart sync response", payload);
    return payload;
  }

  function removeParamAndReload(param) {
    const updatedUrl = new URL(window.location.toString());
    if (!param) {
      // No specific param provided: clear ALL query params
      updatedUrl.search = "";
    } else {
      // Remove only the specified param
      updatedUrl.searchParams.delete(param);
    }
    window.location.href = updatedUrl.toString();
  }

  // Expose globally so other modules can call it
  window.removeParamAndReload = removeParamAndReload;

  function redirectToError() {
    window.location.href = new URL("/404", window.location.origin).toString();
  }

  return {
    init,
    handleCheckout,
    ensureValidSession: ensureValidMercantoToken,
  };
})();

const MercantoFeature = (() => {
  function init() {
    ensureValidMercantoToken();
  }

  async function handleCheckout(event, button) {
    await ensureValidMercantoToken();
    const token = localStorage.getItem(MERCANTO_STORAGE.TOKEN);

    if (!token || token === "null") {
      return false;
    }

    event.preventDefault();
    console.log("[Mercanto] Checkout interception started");
    showFullScreenSpinner(true, false);

    try {
      if (!CUSTOMER_ID || CUSTOMER_ID === "" || CUSTOMER_ID === "null") {
        window.location.href = "/account/login";
        return;
      }

      const lineItems = await fetchCartLineItems();
      const syncMercantoCartResponse = await syncMercantoCart(token, lineItems);
      console.log("[Mercanto] Cart sync success, redirecting", JSON.stringify(syncMercantoCartResponse));

      if (syncMercantoCartResponse) {
        try {
          const url = syncMercantoCartResponse.data.mercanto.cart.result.data.mercanto.data.attributes.cartPageUrl;
          // Clear storefront cart before redirecting to external Mercanto checkout
          await fetch("/cart/clear.js", { method: "POST" });
          window.location.href = url;
        } catch (error) {
          console.error("Mercanto redirect error:", error);
          showFullScreenSpinner(false);
        }

        return;
      }

      console.warn("[Mercanto] Cart sync failed, falling back to native checkout");
      showFullScreenSpinner(false);
      submitNativeCheckout(button);
    } catch (error) {
      console.error("Mercanto checkout error:", error);
      showFullScreenSpinner(false);
      submitNativeCheckout(button);
    }

    return true;
  }

  async function syncMercantoCart(token, lineItems) {
    const refreshToken = localStorage.getItem("mercantoRefreshToken");
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `mutation CartMercanto($accessToken: String!, $refreshToken: String, $customerId: String, $purchaserId: String, $cart: String!) {
          mercanto {
            cart(accessToken: $accessToken, refreshToken: $refreshToken, customerId: $customerId, purchaserId: $purchaserId, cart: $cart) {
              result
              success
              errors {
                message
              }
            }
          }
        }`,
        variables: {
          accessToken: token,
          refreshToken: refreshToken,
          purchaserId: localStorage.getItem("purchaserId"),
          customerId: CUSTOMER_ID,
          cart: JSON.stringify(lineItems),
        },
      }),
    });

    const payload = await response.json();
    console.log("[Mercanto] Cart sync response", payload);

    // Update tokens if backend refreshed them
    const refreshedTokens = payload?.data?.mercanto?.cart?.result?.data?.refreshedTokens;
    if (refreshedTokens?.accessToken) {
      console.log("[Mercanto] Backend refreshed tokens during cart sync, updating localStorage");
      localStorage.setItem("mercantoToken", refreshedTokens.accessToken);
      if (refreshedTokens.refreshToken) {
        localStorage.setItem("mercantoRefreshToken", refreshedTokens.refreshToken);
      }
    }

    return Boolean(payload?.data?.mercanto?.cart?.success);
  }

  return {
    init,
    handleCheckout,
  };
})();

const LoyaltyProgramFeature = (() => {
  const SELECTORS = {
    modalOverlay: ".open-redeem-modal",
    modalContent: ".open-redeem-modal__content",
    modalClose: ".open-redeem-modal__close",
    modalOpen: ".open-redeem-modal_btn",
    modalPointsValue: "#modal-points-value",
    modalConfirmButton: "#modal-confirm-btn",
    goalButtons: ".active-goal-btn, .card-reward__set-goal",
    disabledAddToCart: ".card-product__add-to-cart--disabled",
    redeemButtons: ".redeem-add",
  };

  const MESSAGES = {
    goalUpdateSuccess: JSON.parse('"Ziel erfolgreich aktualisiert!"'),
    goalUpdateError: JSON.parse('"Fehler beim Aktualisieren des Ziels."'),
    redeemError: JSON.parse('"Ein Fehler ist aufgetreten. Bitte versuche es später erneut."'),
    notEnoughPointsAlert: JSON.parse('"Du hast nicht genug Punkte, um diesen Artikel einzulösen."'),
  };

  const LABELS = {
    goalSet: 'Ziel gesetzt',
    setSavingsGoal: 'Als Sparziel festlegen',
    notEnoughPoints: 'Nicht genug Punkte',
  };

  function init() {
    bindModal();
    bindGoalButtons();
    bindRedeemButtons();
    bindDisabledAddToCartButtons();
  }

  function bindModal() {
    const overlays = document.querySelectorAll(SELECTORS.modalOverlay);
    if (!overlays.length) {
      return;
    }

    overlays.forEach((overlay) => {
      overlay.addEventListener("click", (event) => {
        const content = overlay.querySelector(SELECTORS.modalContent);
        if (content && !content.contains(event.target)) {
          overlay.style.display = "none";
        }
      });
    });

    document.querySelectorAll(SELECTORS.modalClose).forEach((button) => {
      button.addEventListener("click", () => {
        overlays.forEach((overlay) => {
          overlay.style.display = "none";
        });
      });
    });

    document.querySelectorAll(SELECTORS.modalOpen).forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        const modal = document.querySelector(SELECTORS.modalOverlay);
        if (!modal) {
          return;
        }

        const productData = {
          variantId: button.getAttribute("data-variant-id") || DEFAULT_MODAL_DATA.variantId,
          customerId: button.getAttribute("data-customer-id") || DEFAULT_MODAL_DATA.customerId,
          rewardId: button.getAttribute("data-reward-id") || DEFAULT_MODAL_DATA.rewardId,
          points: button.getAttribute("data-product-points") || DEFAULT_MODAL_DATA.points,
        };

        populateRedeemModal(productData);
        modal.style.display = "block";
      });
    });
  }

  function populateRedeemModal(productData) {
    const modal = document.querySelector(SELECTORS.modalOverlay);
    if (!modal) {
      return;
    }

    const pointsSpan = modal.querySelector(SELECTORS.modalPointsValue);
    const confirmBtn = modal.querySelector(SELECTORS.modalConfirmButton);

    if (pointsSpan) {
      pointsSpan.textContent = productData.points;
    }

    if (confirmBtn) {
      confirmBtn.setAttribute("data-variant-id", productData.variantId);
      confirmBtn.setAttribute("data-customer-id", productData.customerId);
      confirmBtn.setAttribute("data-reward-id", productData.rewardId);
      confirmBtn.setAttribute("data-product-points", productData.points);
    }
  }

  function bindGoalButtons() {
    const buttons = document.querySelectorAll(SELECTORS.goalButtons);
    if (!buttons.length) {
      return;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => handleGoalClick(event, button));
    });
  }

  async function handleGoalClick(event, button) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    if (button.classList.contains("goal-already-set") || button.classList.contains("card-reward__set-goal-success")) {
      return;
    }

    const productId = button.dataset.productId;
    const customerId = button.dataset.customerId;

    if (!productId || !customerId) {
      return;
    }

    const originalContent = button.innerHTML;
    console.log("[Loyalty] Setting goal for product", productId);
    setButtonLoading(
      button,
      `
      <span style="display: inline-flex; align-items: center; gap: 8px;">
        <span style="width: 16px; height: 16px; border: 2px solid transparent; border-top: 2px solid currentColor; border-radius: 50%; animation: spin 1s linear infinite;"></span>
        Laden...
      </span>
    `
    );

    ensureStyleInjected(
      "goal-spinner-styles",
      "@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }"
    );

    try {
      const success = await updateGoal(customerId, productId);

      if (success) {
        console.log("[Loyalty] Goal set success", productId);
        button.textContent = LABELS.goalSet;
        button.disabled = true;
        button.classList.add("goal-already-set");

        resetOtherGoalButtons(button);
        showNotification({
          type: "success",
          title: "Erfolgreich gespeichert",
          message: MESSAGES.goalUpdateSuccess,
          duration: 2000,
        });
        setTimeout(() => window.location.reload(), 2000);
        return;
      }

      button.innerHTML = originalContent;
      button.disabled = false;
      showNotification({
        type: "error",
        title: "Fehler beim Speichern",
        message: MESSAGES.goalUpdateError,
        duration: 0,
      });
    } catch (error) {
      console.error("Set goal error:", error);
      button.innerHTML = originalContent;
      button.disabled = false;
      showNotification({
        type: "error",
        title: "Fehler beim Speichern",
        message: MESSAGES.goalUpdateError,
        duration: 0,
      });
    }
  }

  function resetOtherGoalButtons(activeButton) {
    const buttons = document.querySelectorAll(SELECTORS.goalButtons);
    buttons.forEach((button) => {
      if (button !== activeButton) {
        button.textContent = LABELS.setSavingsGoal;
        button.disabled = false;
        button.classList.remove("card-reward__set-goal-success");
        button.classList.remove("goal-already-set");
      }
    });
  }

  async function updateGoal(customerId, productId) {
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: buildAuthorizedHeaders(),
      body: JSON.stringify({
        query: `mutation UpdateGoal($customerId: String!, $productId: String) {
          updateGoal(customerId: $customerId, productId: $productId) {
            result
            success
            errors {
              message
            }
          }
        }`,
        variables: {
          customerId: `gid://shopify/Customer/${customerId}`,
          productId: `gid://shopify/Product/${productId}`,
        },
      }),
    });

    const payload = await response.json();
    return payload?.data?.updateGoal?.result?.code === 200;
  }

  function bindRedeemButtons() {
    const buttons = document.querySelectorAll(SELECTORS.redeemButtons);
    if (!buttons.length) {
      return;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => handleRedeemClick(event, button));
    });
  }

  async function handleRedeemClick(event, button) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const variantId = button.dataset.variantId;
    const rewardId = Number(button.dataset.rewardId);
    const customerId = button.dataset.customerId;
    const productPoints = parseFloat(button.dataset.productPoints || "0");

    if (!variantId || !customerId) {
      return;
    }

    const originalContent = button.innerHTML;
    console.log("[Loyalty] Redeem attempt", { variantId, rewardId, customerId });
    setButtonLoading(button, createRedeemSpinner());

    ensureStyleInjected(
      "redeem-spinner-styles",
      `
      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      @keyframes dash { 0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
        100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; } }
    `
    );

    try {
      const eligibility = await checkRewardEligibility(variantId, customerId);
      const rewardPoints = parseFloat(eligibility?.customerPointsBalance || "0");
      let discountCode = eligibility?.eligibleDiscounts?.[0]?.discountCodes?.[0];

      if (!discountCode && rewardPoints > 0 && rewardPoints >= productPoints && rewardId) {
        console.log("[Loyalty] Attempting redemption via RivoJS for reward", rewardId);
        const redemption = await RivoJS.redeemReward(rewardId);
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (redemption?.points_purchase?.code) {
          discountCode = redemption.points_purchase.code;
        } else if (redemption?.error) {
          console.error("Rivo redemption error:", redemption.error);
          throw new Error("Redeem reward failed");
        }
      } else {
        console.log("[Loyalty] No redemption needed, sufficient points available");
      }

      if (!discountCode) {
        if (!rewardPoints || rewardPoints < productPoints) {
          showNotification({
            type: "warning",
            title: "Nicht genug Punkte",
            message: MESSAGES.notEnoughPointsAlert,
            duration: 0,
          });
          button.textContent = LABELS.notEnoughPoints;
          button.disabled = true;
          console.warn("[Loyalty] Redeem blocked due to insufficient points");
          return;
        }

        throw new Error("Missing discount code after eligibility check");
      }

      await ensureVariantInCart(variantId);
      console.log("[Loyalty] Discount code ready, redirecting to cart");
      console.log("[Loyalty] Discount code: ", discountCode);

      const baseUrl = `${window.location.protocol}//${window.location.hostname}`;
      document.querySelectorAll(SELECTORS.modalOverlay).forEach((overlay) => {
        overlay.style.display = "none";
      });
      window.location.href = `${baseUrl}/discount/${discountCode}?redirect=/cart/`;
    } catch (error) {
      console.error("Redeem reward error:", error);
      showNotification({
        type: "error",
        title: "Fehler beim Einlösen",
        message: MESSAGES.redeemError,
        duration: 0,
      });
      button.innerHTML = originalContent;
      button.disabled = false;
    }
  }

  function bindDisabledAddToCartButtons() {
    const buttons = document.querySelectorAll(SELECTORS.disabledAddToCart);
    if (!buttons.length) {
      return;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      });
    });
  }

  async function checkRewardEligibility(variantId, customerId) {
    const response = await fetch(`${BACKEND_URL}/api/graphql`, {
      method: "POST",
      headers: buildAuthorizedHeaders(),
      body: JSON.stringify({
        query: `mutation CheckReward($variantId: String, $customerId: String!, $productId: String) {
          checkReward(variantId: $variantId, customerId: $customerId, productId: $productId) {
            result
            success
            errors {
              message
            }
          }
        }`,
        variables: {
          customerId: `gid://shopify/Customer/${customerId}`,
          variantId: `gid://shopify/ProductVariant/${variantId}`,
        },
      }),
    });

    const payload = await response.json();
    return payload?.data?.checkReward?.result?.data || {};
  }

  async function ensureVariantInCart(variantId) {
    const cartResponse = await fetch("/cart.js");
    if (!cartResponse.ok) {
      throw new Error("Failed to fetch cart");
    }

    const cart = await cartResponse.json();

    const cleared = await fetch("/cart/clear.js", { method: "POST" });
    if (!cleared.ok) {
      throw new Error("Failed to clear cart before redirect");
    }

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!addResponse.ok) {
      throw new Error("Failed to add cart item");
    }

    await addResponse.json();
  }

  function createRedeemSpinner() {
    return `
      <span style="display: inline-block; width: 20px; height: 20px;">
        <svg style="width: 100%; height: 100%; animation: spin 1s linear infinite;" aria-hidden="true" focusable="false" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle style="animation: dash 1.5s ease-in-out infinite;" fill="none" stroke="currentColor" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </span>
    `;
  }

  function setButtonLoading(button, markup) {
    button.disabled = true;
    button.innerHTML = markup;
  }

  function buildAuthorizedHeaders() {
    return {
      Authorization: `Bearer ${BACKEND_API_KEY}`,
      "Content-Type": "application/json",
    };
  }

  return {
    init,
  };
})();

// Check whether a trade-partner handle exists in the TRADE_PARTNER_MAP
function hasKnownTradePartnerHandle(handle) {
  return window.TRADE_PARTNER_MAP && Object.prototype.hasOwnProperty.call(window.TRADE_PARTNER_MAP, handle);
}

// Helper to check and collect missing external customer IDs
function getMissingExternalCustomerIds() {
  // Only check for logged-in customers
  if (!CUSTOMER_ID || CUSTOMER_ID === "null" || CUSTOMER_ID === "") {
    return [];
  }

  const selectedHandle =
    localStorage.getItem("selectedTradePartnerHandle") || localStorage.getItem("selectedTradePartner");
  if (!selectedHandle) {
    return [];
  }

  // Only request external customer IDs for known trade-partner handles.
  // This avoids showing the modal for stale/invalid merchant IDs lingering in localStorage.
  if (window.TRADE_PARTNER_MAP && !hasKnownTradePartnerHandle(selectedHandle)) {
    console.warn("[ExternalCustomerIdCheck] Skipping unknown/stale handle:", selectedHandle);
    return [];
  }

  // Follow profile-edit logic first: read from hidden input value
  let externalIds = [];
  try {
    const hiddenInput = document.getElementById("Profile-ExternalPartnerIds");
    const existingData = hiddenInput && hiddenInput.value;

    if (existingData && existingData.trim() !== "") {
      externalIds = JSON.parse(existingData);
      if (Array.isArray(externalIds)) {
        localStorage.setItem("externalCustomerIds", JSON.stringify(externalIds));
      }
    } else {
      // Fallback for non-profile pages
      const externalIdsJson = localStorage.getItem("externalCustomerIds");
      if (externalIdsJson && externalIdsJson !== "null" && externalIdsJson !== '""') {
        externalIds = JSON.parse(externalIdsJson);
      }
    }
  } catch (e) {
    console.warn("[ExternalCustomerIdCheck] Failed to parse external IDs:", e);
  }

  const hasId = externalIds.some(
    (item) => item.tradePartnerId === selectedHandle || item.partnerName === selectedHandle
  );

  if (!hasId) {
    // Get partner name from trade partner map if available
    let partnerName = selectedHandle;
    if (window.TRADE_PARTNER_MAP && window.TRADE_PARTNER_MAP[selectedHandle]) {
      partnerName = window.TRADE_PARTNER_MAP[selectedHandle].title || selectedHandle;
    }

    if (selectedHandle === "saviva" || selectedHandle === "mercanto") {
      return []; // These partners don't require external customer IDs, so skip the check
    }

    return [
      {
        handle: selectedHandle,
        name: partnerName,
      },
    ];
  }

  return [];
}

const CheckoutInterception = (() => {
  const CHECKOUT_SELECTOR = ".cart__checkout-button";

  function shouldInterceptCheckout() {
    let selectedSupplierHandle = localStorage.getItem("selectedTradePartnerHandle");
    if (
      !selectedSupplierHandle ||
      selectedSupplierHandle === "null" ||
      selectedSupplierHandle === "" ||
      selectedSupplierHandle === "undefined"
    ) {
      selectedSupplierHandle = localStorage.getItem("selectedTradePartner");
    }
    if (!selectedSupplierHandle) {
      return false;
    }

    return (
      selectedSupplierHandle === "saviva" ||
      selectedSupplierHandle === "saviva---integrale" ||
      selectedSupplierHandle === "mercanto"
    );
  }

  async function handleClick(event) {
    if (!shouldInterceptCheckout()) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    // Check if user has external customer ID before proceeding
    const missingIds = getMissingExternalCustomerIds();
    if (missingIds.length > 0) {
      console.log("[CheckoutInterception] Missing external customer IDs:", missingIds);
      window.showExternalCustomerIdModal(missingIds);
      return;
    }

    const button = event.currentTarget || event.target;

    if (await SavivaFeature.handleCheckout(event, button)) {
      return;
    }

    if (await MercantoFeature.handleCheckout(event, button)) {
      return;
    }
  }

  function bindButtons() {
    const buttonsList = document.querySelectorAll(CHECKOUT_SELECTOR);
    let buttons = Array.from(buttonsList);

    const cartNotificationBtn = document.querySelector(".cart-notification__links button");
    if (cartNotificationBtn && !buttons.includes(cartNotificationBtn)) {
      buttons.push(cartNotificationBtn);
    }

    if (!buttons.length) {
      return;
    }

    buttons.forEach((button) => {
      button.removeEventListener("click", handleClick);
      button.addEventListener("click", handleClick);
    });
  }

  function init() {
    bindButtons();

    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        bindButtons();
      });
    }
  }

  return { init };
})();

// Module to handle automatic Handelspartner input population
const HandelspartnerManager = (() => {
  let initialized = false;

  function normalizeText(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function isSlugLike(value) {
    const text = String(value || "").trim();
    return text.includes("-") && !text.includes(" ");
  }

  function toDisplayNameFromSlug(value) {
    return String(value || "")
      .replace(/-/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/(^|\s)\S/g, (m) => m.toUpperCase());
  }

  function getExternalCustomerIdForPartner(tradePartnerHandle, partnerName) {
    if (!tradePartnerHandle && !partnerName) return null;

    const normalizedHandle = normalizeText(tradePartnerHandle);
    const normalizedName = normalizeText(partnerName);

    try {
      // Try to read from hidden input first (profile page)
      const hiddenInput = document.getElementById("Profile-ExternalPartnerIds");
      let externalIds = [];

      if (hiddenInput && hiddenInput.value && hiddenInput.value.trim() !== "") {
        externalIds = JSON.parse(hiddenInput.value);
      } else {
        // Fallback to localStorage
        const externalIdsJson = localStorage.getItem("externalCustomerIds");
        if (externalIdsJson && externalIdsJson !== "null" && externalIdsJson !== '""') {
          externalIds = JSON.parse(externalIdsJson);
        }
      }

      if (!Array.isArray(externalIds)) return null;

      // Find matching external customer ID by tradePartnerId or partnerName (case-insensitive)
      const match = externalIds.find((item) => {
        const itemTradePartnerId = normalizeText(item?.tradePartnerId);
        const itemPartnerName = normalizeText(item?.partnerName);

        return (
          (normalizedHandle && itemTradePartnerId === normalizedHandle) ||
          (normalizedName && itemPartnerName === normalizedName)
        );
      });

      return match ? match.externalCustomerId : null;
    } catch (error) {
      console.warn("[HandelspartnerManager] Failed to get external customer ID:", error);
      return null;
    }
  }

  function buildHandelspartnerValue() {
    try {
      // Get selected trade partner from localStorage
      let selectedHandle = String(localStorage.getItem("selectedTradePartnerHandle") || "").trim();
      let selectedName = String(localStorage.getItem("selectedTradePartner") || "").trim();

      if (!selectedHandle || selectedHandle === "null") {
        selectedHandle = selectedName;
      }

      if (!selectedHandle || selectedHandle === "null") {
        // Return null (not empty string) to signal no update should occur
        return null;
      }

      // Keep merchant naming stable: prefer selectedTradePartner display name when available.
      // This avoids mixed values like "Vermo ag" and "Vermo AG" across products.
      let partnerName = selectedName;

      // If selected name is missing or slug-like, fallback to TRADE_PARTNER_MAP title.
      if ((!partnerName || partnerName === "null" || isSlugLike(partnerName)) &&
          window.TRADE_PARTNER_MAP &&
          window.TRADE_PARTNER_MAP[selectedHandle]) {
        partnerName = window.TRADE_PARTNER_MAP[selectedHandle].title || partnerName;
      }

      // Last fallback for slug-like names when map is not available.
      if (!partnerName || partnerName === "null") {
        partnerName = selectedHandle;
      }
      if (isSlugLike(partnerName)) {
        partnerName = toDisplayNameFromSlug(partnerName);
      }

      // Ensure first letter is uppercase for consistent display
      if (partnerName) {
        partnerName = partnerName.charAt(0).toUpperCase() + partnerName.slice(1);
      }

      // Format: "PartnerName (tradePartnerId)" when handle is distinct from name
      let handelspartnerValue =
        normalizeText(partnerName) === normalizeText(selectedHandle)
          ? partnerName
          : `${partnerName} (${selectedHandle})`;

      // Check if we have an external customer ID for this partner
      const externalCustomerId = getExternalCustomerIdForPartner(selectedHandle, partnerName);

      // If external customer ID exists, append it: "PartnerName (tradePartnerId) - externalCustomerId"
      if (externalCustomerId) {
        handelspartnerValue += ` - ${externalCustomerId}`;
      }

      return handelspartnerValue;
    } catch (error) {
      console.error("[HandelspartnerManager] Failed to build Handelspartner value:", error);
      return null; // Return null to prevent clearing existing values
    }
  }

  function updateAllHandelspartnerInputs() {
    try {
      const handelspartnerValue = buildHandelspartnerValue();
      // Only update if we have a valid value. null or empty means logic failed or no merchant selected.
      // In that case, preserve whatever is already in the input.
      if (handelspartnerValue) {
        const inputs = document.querySelectorAll('.render-trade-partner[name="properties[Handelspartner]"]');
        inputs.forEach((input) => {
          input.value = handelspartnerValue;
        });
      }
    } catch (error) {
      console.error("[HandelspartnerManager] Error updating Handelspartner inputs:", error);
      // Do nothing on error - preserve existing values
    }
  }

  function init() {
    // Always refresh inputs (bfcache may have stale values)
    updateAllHandelspartnerInputs();

    // Only register listeners/observers once
    if (initialized) return;
    initialized = true;

    // Re-run on cart updates if PUB_SUB is available
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        updateAllHandelspartnerInputs();
      });
    }
  }

  return {
    init,
    updateAllHandelspartnerInputs, // Expose for manual triggers
  };
})();

const SupplierAvailabilityFeature = (() => {
  let isHandlingTradePartnerChange = false;
  let lastTradePartnerValue = `${localStorage.getItem("selectedTradePartner") || ""}::${
    localStorage.getItem("selectedTradePartnerHandle") || ""
  }`;

  function init() {
    function triggerExternalCustomerIdModalIfNeeded(source = "unknown") {
      const isProfilePage =
        window.location.pathname.includes("/pages/profile-edit") ||
        window.location.pathname.includes("/pages/profile-create");

      if (isProfilePage) {
        return;
      }

      const modal = document.getElementById("external-customer-id-modal");
      if (modal && modal.style.display === "flex") {
        return;
      }

      if (typeof window.isExternalCustomerIdModalAutoDismissed === "function" &&
          window.isExternalCustomerIdModalAutoDismissed()) {
        return;
      }

      // Don't show external-customer-id modal while the supplier selection modal
      // is already open (e.g. stale trade-partner recovery).
      const supplierModal = document.getElementById("supplier-availability-modal");
      if (supplierModal && supplierModal.style.display === "flex") {
        return;
      }

      const missingIds = getMissingExternalCustomerIds();
      if (missingIds.length > 0) {
        console.log(`[${source}] Selected merchant missing external customer ID, showing modal:`, missingIds);
        window.showExternalCustomerIdModal(missingIds);
      }
    }

    async function handleTradePartnerChange() {
      if (isHandlingTradePartnerChange) {
        return;
      }

      // Always re-apply canonical merchant text to product form inputs when selection changes.
      if (typeof HandelspartnerManager !== "undefined" &&
          typeof HandelspartnerManager.updateAllHandelspartnerInputs === "function") {
        HandelspartnerManager.updateAllHandelspartnerInputs();
      }

      // Reset the auto-dismiss flag so the external-customer-id modal can
      // re-appear for the newly selected trade partner.
      if (typeof window.isExternalCustomerIdModalAutoDismissed === "function") {
        window._resetExternalCustomerIdModalDismiss?.();
      }

      // Check if the newly selected merchant is stale/invalid before proceeding.
      // This handles the case where a user switches from a valid merchant to a fake one.
      await recoverFromStaleTradePartnerSelection();

      const selectedTradePartnerHandle = localStorage.getItem("selectedTradePartnerHandle");

      // If recovery cleared the selection (stale merchant), don't proceed with the normal flow.
      if (!selectedTradePartnerHandle || selectedTradePartnerHandle === "null" || selectedTradePartnerHandle === "") {
        return;
      }

      const firstSection = document.querySelector(".supplier-availability-check");
      if (firstSection) {
        isHandlingTradePartnerChange = true;
        runSupplierAvailabilityCheck(
          firstSection,
          selectedTradePartnerHandle,
          false
        ).finally(() => {
          isHandlingTradePartnerChange = false;
          setTimeout(() => triggerExternalCustomerIdModalIfNeeded("TradePartnerChange"), 200);
        });
      } else {
        setTimeout(() => triggerExternalCustomerIdModalIfNeeded("TradePartnerChange"), 200);
      }
    }

    function checkForTradePartnerChanges() {
      const currentValue = `${localStorage.getItem("selectedTradePartner") || ""}::${
        localStorage.getItem("selectedTradePartnerHandle") || ""
      }`;
      if (currentValue !== lastTradePartnerValue) {
        console.log("[SupplierAvailability] Trade partner changed:", lastTradePartnerValue, "->", currentValue);
        lastTradePartnerValue = currentValue;
        handleTradePartnerChange();
      }
    }

    async function recoverFromStaleTradePartnerSelection() {
      const rawSelectedPartner = String(localStorage.getItem("selectedTradePartner") || "").trim();
      const rawSelectedHandle = String(localStorage.getItem("selectedTradePartnerHandle") || "").trim();
      const selectedHandle =
        rawSelectedHandle && rawSelectedHandle !== "null" && rawSelectedHandle !== "undefined"
          ? rawSelectedHandle
          : rawSelectedPartner;

      if (!selectedHandle || selectedHandle === "null" || selectedHandle === "undefined") {
        return;
      }

      if (window.TRADE_PARTNER_MAP && hasKnownTradePartnerHandle(selectedHandle)) {
        return;
      }

      console.warn("[SupplierAvailability] Found stale trade partner selection, resetting:", selectedHandle);
      localStorage.removeItem("selectedTradePartner");
      localStorage.removeItem("selectedTradePartnerHandle");

      lastTradePartnerValue = `${localStorage.getItem("selectedTradePartner") || ""}::${
        localStorage.getItem("selectedTradePartnerHandle") || ""
      }`;

       // Disable product form buttons if helper is available, to avoid actions with a stale trade partner
       if (typeof window.disableProductFormButtons === "function") {
         window.disableProductFormButtons();
       }

      // Reset all trade partner dropdowns to the default placeholder option
      document.querySelectorAll(".trade-partner-select").forEach((select) => {
        select.selectedIndex = 0;
      });

      // Notify the user that their previous selection is no longer valid.
      showNotification({
        type: "warning",
        title: 'Lieferant nicht mehr verfügbar',
        message: 'Der zuvor ausgewählte Lieferant ist nicht mehr verfügbar. Bitte wählen Sie einen neuen aus.',
        duration: 5000,
      });

      // For stale selections, show the supplier selection modal so the user can pick a valid trade partner.
      const supplierModal = document.getElementById("supplier-availability-modal");
      if (supplierModal) {
        supplierModal.style.display = "flex";
      }
    }

    function scheduleInitialExternalCustomerIdChecks() {
      [300, 1200, 2500].forEach((delay) => {
        setTimeout(() => {
          triggerExternalCustomerIdModalIfNeeded(`InitialLoad(${delay}ms)`);
        }, delay);
      });
    }

    setInterval(checkForTradePartnerChanges, 100);
    // Run stale recovery FIRST so invalid handles are cleared before any
    // external-customer-id modal checks fire.
    recoverFromStaleTradePartnerSelection();
    runSupplierAvailabilityCheck().finally(() => {
      scheduleInitialExternalCustomerIdChecks();
    });

    window.addEventListener("storage", (event) => {
      if (event.key === "selectedTradePartner" || event.key === "selectedTradePartnerHandle") {
        checkForTradePartnerChanges();
      }
    });
  }

  function initializeSupplierAvailabilityCheck(sectionElement) {
    const supplierSelect = sectionElement.querySelector(".supplier-availability-check__supplier-select");
    const submitButton = sectionElement.querySelector(".supplier-availability-check__submit-button");
    const form = sectionElement.querySelector(".supplier-availability-check__form");

    if (!form) return;

    form.addEventListener("submit", async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const supplierSelectValue = supplierSelect.value;
      const supplierSelectPartnerHandle = supplierSelect.dataset.partnerHandle;

      await runSupplierAvailabilityCheck(sectionElement, supplierSelectPartnerHandle, false);
    });
  }

  async function runSupplierAvailabilityCheck(sectionElement, supplierSelectHandle, isInit = true) {
    const isLoggedIn = !!(CUSTOMER_ID && CUSTOMER_ID !== "" && CUSTOMER_ID !== "null");

    let deleteCatalogData;

    if (!isInit) {
      try {
        showFullScreenSpinner(true, false);

        if (
          (localStorage.getItem("integraleToken") !== null && localStorage.getItem("integraleToken") != "null") ||
          (localStorage.getItem("mercantoToken") !== null && localStorage.getItem("mercantoToken") != "null")
        ) {
          fetch("/cart/clear.js", { method: "POST" });
        }

        const deleteCatalog = await fetch(`${BACKEND_URL}/api/graphql`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query:
              "mutation DeleteCatalog($customerId: String) {\n deleteCatalog(customerId:$customerId){\n        result \n        success\n        errors {\n        message\n    }\n  } \n}",
            variables: {
              customerId: CUSTOMER_ID,
            },
          }),
        });

        deleteCatalogData = await deleteCatalog.json();
      } catch (error) {
        console.error("Error deleting catalog:", error);
        showFullScreenSpinner(false);
      }
    }

    if (!isSavivaHandshakeRunning && !supplierSelectHandle) {
      if (
        ((localStorage.getItem("integraleToken") === null || localStorage.getItem("integraleToken") == "null") &&
          localStorage.getItem("selectedTradePartnerHandle") === "saviva") ||
        ((localStorage.getItem("mercantoToken") === null || localStorage.getItem("mercantoToken") == "null") &&
          localStorage.getItem("selectedTradePartnerHandle") === "mercanto")
      ) {
        const tradePartnerSelections = document.querySelectorAll(".trade-partner-select");
        tradePartnerSelections.forEach((select) => {
          select.selectedIndex = 0;
        });
        localStorage.removeItem("selectedTradePartner");

        if (typeof window.disableProductFormButtons === "function") {
          console.log("[SupplierAvailability] Triggering disableProductFormButtons");
          window.disableProductFormButtons();
        } else {
          console.log("[SupplierAvailability] disableProductFormButtons not found globally");
        }
      } else if (
        localStorage.getItem("selectedTradePartner") !== null &&
        localStorage.getItem("selectedTradePartner") !== "null" &&
        localStorage.getItem("selectedTradePartner") !== ""
      ) {
        if (typeof window.enableProductFormButtons === "function") {
          console.log("[SupplierAvailability] Triggering enableProductFormButtons");
          window.enableProductFormButtons();
        } else {
          console.log("[SupplierAvailability] enableProductFormButtons not found globally");
        }
      }
    }

    switch (supplierSelectHandle) {
      case "saviva":
        fetch("/cart/clear.js", { method: "POST" });
        if (!isLoggedIn) {
          window.location.href = "/account/login";
          return;
        }

        showFullScreenSpinner(false);
        showMerchantGuestAuthModal(sectionElement);
        break;

      case "mercanto":
        fetch("/cart/clear.js", { method: "POST" });
        if (!isLoggedIn) {
          window.location.href = "/account/login";
          return;
        }

        await ensureValidMercantoToken();

        // const existingMercantoToken = localStorage.getItem('mercantoToken');
        // if (existingMercantoToken && existingMercantoToken !== 'null') {
        //   console.log('[SupplierAvailability] Mercanto token already exists, skipping modal');
        //   showFullScreenSpinner(false);
        //   return;
        // }

        showFullScreenSpinner(false);
        showMerchantGuestAuthModal(sectionElement);
        // showMercantoModal(sectionElement);
        break;

      default:
        if (!isInit) {
          localStorage.removeItem("integraleToken");
          clearMercantoSession();
          localStorage.removeItem("purchaserId");
        }

        break;
    }

    if (parseInt(deleteCatalogData?.data?.deleteCatalog?.result?.deletedCatalogIds?.length) ?? 0 > 0) {
      console.log("[SupplierAvailability] Catalog deleted, reloading page.");
      if (supplierSelectHandle !== "mercanto" && supplierSelectHandle !== "saviva") {
        window.location.reload();
      }
    }

    if (!isInit) {
      showFullScreenSpinner(false);
    }
  }

  function encodePassword(password) {
    return btoa(password);
  }

  function showMercantoModal(sectionElement) {
    const mercantoModal = document.querySelectorAll(".mercanto-auth__modal");
    if (!mercantoModal) return;

    for (const modal of mercantoModal) {
      modal.style.display = "none";
      modal.style.display = "block";

      const mercantoCloseButton = modal.querySelector(".mercanto-auth__modal-close");
      if (mercantoCloseButton) {
        mercantoCloseButton.addEventListener("click", function () {
          modal.style.display = "none";
          runSupplierAvailabilityCheck();
        });
      }

      const mercantoLoginForm = modal.querySelector("#mercanto-login-form");
      if (mercantoLoginForm) {
        mercantoLoginForm.addEventListener("submit", function (e) {
          e.preventDefault();
          handleMercantoLogin(e, modal);
        });
      }
    }
  }

  function showSavivaModal(purchasers) {
    const savivaModals = document.querySelectorAll(".saviva-auth__modal");
    if (!savivaModals.length) return;

    // If explicitly asked to hide, close all and exit
    if (purchasers === false) {
      savivaModals.forEach((modal) => {
        modal.style.display = "none";
      });
      return;
    }

    savivaModals.forEach((modal) => {
      // Populate select with purchasers
      const selectEl = modal.querySelector('#saviva-purchaser-selection-form select[name="purchaserId"]');
      const submitButton = modal.querySelector('#saviva-purchaser-selection-form button[type="submit"]');

      if (selectEl && Array.isArray(purchasers)) {
        Array.from(selectEl.querySelectorAll("option:not([disabled])")).forEach((o) => o.remove());
        purchasers.forEach((p) => {
          const opt = document.createElement("option");
          opt.value = p.id;
          opt.textContent = p.name || p.id;
          selectEl.appendChild(opt);
        });
      }

      // Show modal (block to match mercanto logic)
      modal.style.display = "block";

      // Enable/disable submit button based on selection
      if (selectEl && submitButton) {
        selectEl.addEventListener("change", function () {
          const isPlaceholderSelected = !selectEl.value || selectEl.selectedIndex === 0;
          submitButton.disabled = isPlaceholderSelected;
        });
      }

      // Close button
      const closeBtn = modal.querySelector(".saviva-auth__modal-close");
      if (closeBtn) {
        closeBtn.addEventListener(
          "click",
          () => {
            modal.style.display = "none";
            runSupplierAvailabilityCheck();
          },
          { once: true }
        );
      }

      // Outside click close (same pattern as mercanto modal)
      modal.addEventListener("click", (e) => {
        const content = modal.querySelector(".saviva-auth__modal-content");
        if (content && !content.contains(e.target)) {
          modal.style.display = "none";
        }
      });

      const form = modal.querySelector("#saviva-purchaser-selection-form");
      if (form) {
        form.addEventListener("submit", handleSavivaPurchaserSelection, { once: true });
      }
    });
  }

  // Make globally accessible for cross-module usage
  window.showSavivaModal = showSavivaModal;
  window.hideSavivaModal = function () {
    const savivaModals = document.querySelectorAll(".saviva-auth__modal");
    savivaModals.forEach((modal) => {
      modal.style.display = "none";
    });
  };

  async function handleSavivaPurchaserSelection(e) {
    e.preventDefault();
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const selectEl = form.querySelector('select[name="purchaserId"]');
    if (!selectEl || !selectEl.value) return;

    const purchaserId = selectEl.value;
    const token = localStorage.getItem("integraleToken");
    if (!token || token === "null") {
      showNotification({
        type: "error",
        title: "Verbindungsfehler",
        message: "Kein Saviva Token gefunden. Bitte erneut verbinden.",
        duration: 0,
      });
      return;
    }

    // Save the selected purchaserId to localStorage for future use
    localStorage.setItem("purchaserId", purchaserId);

    // Visual loading state
    const originalBtnContent = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span style="display:inline-flex;align-items:center;gap:8px;"><span class="saviva-auth__spinner"></span> Synchronisiere Produkte...</span>`;

    try {
      showSavivaModal(false);
      showFullScreenSpinner(true, true);
      const productsResponse = await fetch(`${BACKEND_URL}/api/graphql`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `mutation FetchIntegraleProducts($accessToken: String!, $purchaserId: String!, $customerId: String!) {\n  integrale {\n    fetchIntegraleProducts(accessToken: $accessToken, purchaserId: $purchaserId, customerId: $customerId) {\n      success\n      result\n      errors { message }\n    }\n  }\n}`,
          variables: { accessToken: token, purchaserId, customerId: CUSTOMER_ID },
        }),
      });

      const data = await productsResponse.json();
      const op = data?.data?.integrale?.fetchIntegraleProducts;
      if (!op?.success) {
        console.warn("[SavivaModal] fetchIntegraleProducts unsuccessful", op?.errors);
        showNotification({
          type: "error",
          title: "Fehler beim Laden",
          message: "Produkte konnten nicht geladen werden. Versuchen Sie es erneut.",
          duration: 0,
        });
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalBtnContent;
        showFullScreenSpinner(false);
        return;
      }

      if (op.result.data.catalog.data.createCatalog.success) {
        const catalogVariants = op.result.data.catalog.data.createCatalog?.result?.data?.catalogVariants;

        if (catalogVariants && catalogVariants?.length > 0) {
          localStorage.setItem("catalogVariants", JSON.stringify(catalogVariants));
        }
      } else {
        showNotification({
          type: "error",
          title: "Fehler beim Laden",
          message:
            "Failed to fetch products: " +
            (op.result.data.catalog.data.createCatalog?.result?.message || "Unknown error"),
          duration: 0,
        });
      }

      window.removeParamAndReload();
    } catch (error) {
      console.error("[SavivaModal] Fehler beim Laden der Produkte:", error);
      showNotification({
        type: "error",
        title: "Fehler",
        message: "Es ist ein Fehler aufgetreten. Bitte erneut versuchen.",
        duration: 0,
      });
      showFullScreenSpinner(false);
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalBtnContent;
      return;
    }
  }

  function showMerchantGuestAuthModal(sectionElement) {
    const mercantoModal = document.querySelectorAll(".guest-auth__modal");
    if (!mercantoModal) return;

    for (const modal of mercantoModal) {
      modal.style.display = "none";
      modal.style.display = "block";

      const mercantoCloseButton = modal.querySelector(".guest-auth__modal-close");
      if (mercantoCloseButton) {
        mercantoCloseButton.addEventListener("click", function () {
          modal.style.display = "none";
          runSupplierAvailabilityCheck();
        });
      }

      const loginWithMerchant = modal.querySelector(".guest-auth_supplier-login");
      if (loginWithMerchant) {
        localStorage.setItem("checkoutType", "merchant");
        loginWithMerchant.addEventListener("click", function (e) {
          e.preventDefault();
          switch (localStorage.getItem("selectedTradePartnerHandle")) {
            case "mercanto":
              modal.style.display = "none";
              showMercantoModal(sectionElement);
              break;
            case "saviva":
              const existingToken = localStorage.getItem("integraleToken");
              const recentRedirect = sessionStorage.getItem("savivaRedirectTime");
              const now = Date.now();
              // if (existingToken && existingToken !== "null") {
              //   console.log("[SupplierAvailability] Saviva token already exists, skipping redirect");
              //   return;
              // }

              // if (recentRedirect && now - parseInt(recentRedirect) < 30000) {
              //   console.log("[SupplierAvailability] Recent Saviva redirect detected, skipping");
              //   return;
              // }

              sessionStorage.setItem("savivaRedirectTime", now.toString());
              window.location.href = SAVIVA_AUTH_URL;
              break;
            default:
              console.warn("Unknown trade partner selected");
          }
        });
      }

      const loginWithGuest = modal.querySelector(".guest-auth_guest-login");
      if (loginWithGuest) {
        loginWithGuest.addEventListener("click", function (e) {
          e.preventDefault();
          localStorage.removeItem("catalogVariants");
          const currentHandle = localStorage.getItem("selectedTradePartnerHandle");

          // Dynamically find guest handle from trade partner mapping
          let guestHandle = null;
          let guestSlugifiedValue = null;

          if (window.TRADE_PARTNER_MAP && currentHandle) {
            // Get the current partner's title
            const currentPartner = window.TRADE_PARTNER_MAP[currentHandle];

            if (currentPartner) {
              const merchantTitle = currentPartner.title;
              const guestTitle = merchantTitle + " (Gastbestellung)";

              console.log("[GuestAuth] Looking for guest partner with title:", guestTitle);

              // Find the partner with matching guest title
              for (const [handle, data] of Object.entries(window.TRADE_PARTNER_MAP)) {
                if (data.title === guestTitle) {
                  guestHandle = handle;
                  // Slugify the title to match the pattern used in select dropdowns
                  guestSlugifiedValue = guestTitle.toLowerCase().replace(/ /g, "-");
                  console.log("[GuestAuth] Found guest handle:", guestHandle, "slugified value:", guestSlugifiedValue);
                  break;
                }
              }
            }
          }

          // Fallback to hardcoded values if dynamic lookup fails
          if (!guestHandle) {
            console.warn("[GuestAuth] Dynamic lookup failed, using fallback mapping for handle:", currentHandle);
            switch (currentHandle) {
              case "mercanto":
                guestHandle = "5171";
                guestSlugifiedValue = "pistor---mercanto-(gastbestellung)";
                break;
              case "saviva":
                guestHandle = "558475";
                guestSlugifiedValue = "integrale-(gastbestellung)";
                break;
              default:
                modal.style.display = "none";
                return;
            }
          }
          const cleared = fetch("/cart/clear.js", { method: "POST" });

          localStorage.setItem("selectedTradePartner", guestSlugifiedValue);
          localStorage.setItem("selectedTradePartnerHandle", guestHandle);
          localStorage.setItem("checkoutType", "guest");
          modal.style.display = "none";
          window.location.reload();
        });
      }
    }
  }

  async function handleMercantoLogin(e, sectionElement) {
    const submitButton = e.target.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;

    submitButton.disabled = true;
    submitButton.innerHTML = `
      <span style="display: inline-flex; align-items: center; gap: 8px;">
        <span style="width: 16px; height: 16px; border: 2px solid transparent; border-top: 2px solid currentColor; border-radius: 50%; animation: spin 1s linear infinite;"></span>
        Laden...
      </span>
    `;

    const email = e.target.email.value;
    const password = e.target.password.value;
    const encodedPassword = encodePassword(password);

    try {
      const response = await fetch(`${BACKEND_URL}/api/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query:
            "mutation MercantoLogin($email: String!, $password: String!) {\n mercanto {\n login(email: $email, password: $password) {\n        success\n        result\n        errors {\n        message\n   }\n   }\n  } \n}",
          variables: {
            email: email,
            password: encodedPassword,
          },
        }),
      });

      const data = await response.json();
      console.log("[Mercanto] Full login response:", JSON.stringify(data, null, 2));
      const attributes = data?.data?.mercanto?.login?.result?.data?.data?.attributes;
      console.log("[Mercanto] Extracted attributes:", attributes);
      const token = attributes?.accessToken;
      const refreshToken = attributes?.refreshToken;
      const expiresIn = Number(attributes?.expiresIn);
      console.log("[Mercanto] Extracted tokens:", { token: !!token, refreshToken: !!refreshToken, expiresIn });

      if (!token) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
        showNotification({
          type: "error",
          title: "Login fehlgeschlagen",
          message: data?.data?.mercanto?.login?.errors?.[0]?.message || "Unknown error",
          duration: 0,
        });
        return;
      }

      persistMercantoSession({
        accessToken: token,
        refreshToken: refreshToken,
        expiresIn: expiresIn,
      });
      await handleMercantoMerchants(token, sectionElement, submitButton, originalButtonText);
    } catch (error) {
      console.error("Error during Mercanto login:", error);
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
      showNotification({
        type: "error",
        title: "Fehler",
        message: "An error occurred during login. Please try again.",
        duration: 0,
      });
    }
  }

  async function handleMercantoMerchants(token, sectionElement, submitButton, originalButtonText) {
    const refreshToken = localStorage.getItem("mercantoRefreshToken");
    try {
      const response = await fetch(`${BACKEND_URL}/api/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query:
            "mutation MercantoMerchants($token: String!, $refreshToken: String) {\n mercanto {\n merchants(token: $token, refreshToken: $refreshToken) {\n        result\n        success\n        errors {\n        message\n   }\n   }\n  } \n}",
          variables: { token: token, refreshToken: refreshToken },
        }),
      });

      const data = await response.json();

      // Update tokens if backend refreshed them
      const refreshedTokens = data?.data?.mercanto?.merchants?.result?.data?.refreshedTokens;
      if (refreshedTokens?.accessToken) {
        console.log("[Mercanto] Backend refreshed tokens during merchants fetch, updating localStorage");
        localStorage.setItem("mercantoToken", refreshedTokens.accessToken);
        if (refreshedTokens.refreshToken) {
          localStorage.setItem("mercantoRefreshToken", refreshedTokens.refreshToken);
        }
      }

      if (data?.data?.mercanto?.merchants?.result?.success) {
        const merchants = data.data.mercanto.merchants.result.data?.merchants;

        if (!merchants || merchants.length === 0) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
          showNotification({
            type: "warning",
            title: "Keine Händler gefunden",
            message: "No merchants found for this account.",
            duration: 0,
          });
          return;
        }

        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;

        showMerchantSelection(merchants, token, sectionElement);
      } else {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
        showNotification({
          type: "error",
          title: "Fehler beim Laden",
          message:
            "Failed to fetch merchants: " +
            (data?.data?.mercanto?.merchants?.result?.errors?.[0]?.message || "Unknown error"),
          duration: 0,
        });
      }
    } catch (error) {
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
      console.error("Error while fetching merchants:", error);
      showNotification({
        type: "error",
        title: "Fehler",
        message: "An error occurred. Please try again.",
        duration: 0,
      });
    }
  }

  function showMerchantSelection(merchants, token, sectionElement) {
    const modalBody = sectionElement.querySelector(".mercanto-auth__modal-body");
    if (!modalBody) return;

    modalBody.innerHTML = `
      <h3>Geschäftseinheit auswählen</h3>
      <form id="merchant-selection-form">
        <select name="merchantId" required>
          <option disabled selected>Bitte Geschäftseinheit auswählen...</option>
          ${merchants
            .map((merchant) => {
              const optionVal = merchant.companyUserId || merchant.name || merchant.id;
              const merchantName =
                merchant.businessUnitName || merchant.companyName || merchant.attributes?.merchantName;
              return `<option value="${optionVal}">${merchantName}</option>`;
            })
            .join("")}
        </select>
        <button type="submit" style="margin-top: 16px;" disabled>Weiter</button>
      </form>
    `;

    const merchantForm = modalBody.querySelector("#merchant-selection-form");
    const submitButton = merchantForm.querySelector('button[type="submit"]');
    const merchantSelect = merchantForm.querySelector('select[name="merchantId"]');

    // Enable/disable submit button based on selection
    merchantSelect.addEventListener("change", function () {
      const isPlaceholderSelected = !merchantSelect.value || merchantSelect.selectedIndex === 0;
      submitButton.disabled = isPlaceholderSelected;
    });

    merchantForm.addEventListener("submit", function (e) {
      e.preventDefault();
      handleMerchantSelection(e, merchants, token);
    });
  }

  async function handleMerchantSelection(e, merchants, token) {
    e.target.disabled = true;
    const selectedMerchantId = e.target.merchantId.value;
    // Persist purchaserId so other flows (checkout/cart sync) can access it
    try {
      localStorage.setItem("purchaserId", selectedMerchantId);
      // Also expose as a global variable for immediate access
      window.purchaserId = selectedMerchantId;
    } catch (err) {
      console.warn("Failed to persist purchaserId to localStorage:", err);
    }
    const submitButton = e.target.querySelector('button[type="submit"]');
    localStorage.removeItem("catalogVariants");
    submitButton.innerHTML = `
      <span style="display: inline-flex; align-items: center; gap: 8px;">
        <span style="width: 16px; height: 16px; border: 2px solid transparent; border-top: 2px solid currentColor; border-radius: 50%; animation: spin 1s linear infinite;"></span>
        Synchronisiere Produkte...
      </span>
    `;

    try {
      if (!selectedMerchantId) {
        showNotification({
          type: "error",
          title: "Fehler",
          message: "Missing purchaser ID. Please select a purchaser before syncing products.",
          duration: 0,
        });
        submitButton.innerHTML = 'Synchronisiere Produkte...';
        e.target.disabled = false;
        return;
      }

      const storedToken = localStorage.getItem("mercantoToken");
      const storedRefreshToken = localStorage.getItem("mercantoRefreshToken");

      const response = await fetch(`${BACKEND_URL}/api/graphql`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query:
            "mutation MercantoProducts($token: String!, $refreshToken: String, $merchant: String!, $customerId: String!, $purchaserId: String!) {\n mercanto {\n products(token: $token, refreshToken: $refreshToken, merchant: $merchant, customerId: $customerId, purchaserId: $purchaserId) {\n        result\n        success\n        errors {\n        message\n   }\n   }\n  } \n}",
          variables: {
            token: storedToken,
            refreshToken: storedRefreshToken,
            merchant: selectedMerchantId,
            customerId: CUSTOMER_ID,
            purchaserId: selectedMerchantId,
          },
        }),
      });

      const data = await response.json();

      // Update tokens if backend refreshed them
      const refreshedTokens = data?.data?.mercanto?.products?.result?.data?.refreshedTokens;
      if (refreshedTokens?.accessToken) {
        console.log("[Mercanto] Backend refreshed tokens during products sync, updating localStorage");
        localStorage.setItem("mercantoToken", refreshedTokens.accessToken);
        if (refreshedTokens.refreshToken) {
          localStorage.setItem("mercantoRefreshToken", refreshedTokens.refreshToken);
        }
      }

      if (data?.data?.mercanto?.products?.result?.success) {
        const catalogVariants =
          data.data.mercanto.products.result?.data?.catalog?.data?.createCatalog?.result?.data?.catalogVariants;

        if (catalogVariants && catalogVariants?.length > 0) {
          localStorage.setItem("catalogVariants", JSON.stringify(catalogVariants));
        }
        window.location.reload();
      } else {
        showNotification({
          type: "error",
          title: "Fehler beim Laden",
          message: "Failed to fetch products: " + (data?.data?.mercanto?.products?.result?.message || "Unknown error"),
          duration: 0,
        });
      }
    } catch (error) {
      console.error("Error while fetching products:", error);
      showNotification({
        type: "error",
        title: "Fehler",
        message: "An error occurred while fetching products. Please try again.",
        duration: 0,
      });
    }
  }

  return {
    init,
  };
})();

const LandingPageButtonAnalytics = (() => {
  const LANDING_PAGE_SLUG = "pages/knorr-kochcreme";
  const SESSION_STORAGE_KEY = "ufsLandingAnalyticsSessionId";
  let isInitialized = false;
  function matchesLandingPageDomSignature() {
    const pageText = document.body?.textContent || "";
    const hasHeading = pageText.includes("Die pflanzenbasierte Basis für jede Küche");
    const hasProductLink = !!document.querySelector(
      'a[href*="knorr-professional-kochcreme-pflanzenbasiert-1-l"]'
    );

    return hasHeading && hasProductLink;
  }

  function resolvePageIdentifier() {
    return window.location.pathname;
  }

  function shouldTrackCurrentPage() {
    const currentPath = (window.location.pathname || "").toLowerCase();

    return currentPath.includes(LANDING_PAGE_SLUG) || matchesLandingPageDomSignature();
  }

  function getSessionId() {
    try {
      const existing = localStorage.getItem(SESSION_STORAGE_KEY);
      if (existing) return existing;

      const generated =
        (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

      localStorage.setItem(SESSION_STORAGE_KEY, generated);
      return generated;
    } catch (_error) {
      return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    }
  }

  function getTextForElement(element) {
    if (!element) return "";

    const aria = element.getAttribute("aria-label");
    if (aria) return aria.trim();

    if (element.tagName === "INPUT") {
      return (element.value || "").trim();
    }

    return (element.textContent || "").replace(/\s+/g, " ").trim();
  }

  function getButtonHref(element) {
    if (!element) return "";

    if (element.tagName === "A") {
      return element.href || "";
    }

    const parentLink = element.closest("a[href]");
    return parentLink?.href || "";
  }

  function buildPayload(target) {
    const sectionElement = target.closest("[id^='shopify-section-'], [data-section-id]");
    const sectionId =
      sectionElement?.getAttribute("data-section-id") ||
      sectionElement?.id ||
      "";

    return {
      eventType: "button_click",
      source: "theme",
      pageTemplate: resolvePageIdentifier(),
      pagePath: window.location.pathname,
      pageTitle: document.title,
      buttonText: getTextForElement(target),
      buttonHref: getButtonHref(target),
      buttonId: target.id || "",
      buttonClasses: target.className || "",
      sectionId,
      elementTag: (target.tagName || "").toLowerCase(),
      customerId: window.CUSTOMER_ID || "",
      shopDomain: window.location.hostname,
      sessionId: getSessionId(),
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      clickedAtIso: new Date().toISOString(),
      metadata: {
        pathname: window.location.pathname || "",
      },
    };
  }

  function sendEvent(payload) {
    const endpoint = `${BACKEND_URL}/analytics`;
    const body = JSON.stringify(payload);

    fetch(endpoint, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
      },
      body,
    }).catch((error) => {
      console.warn("[LandingPageButtonAnalytics] Failed to send analytics event", error);
    });
  }

  function handleClick(event) {
    const clickable = event.target?.closest(
      "a[href], button, [role='button'], input[type='button'], input[type='submit']"
    );

    if (!clickable) return;

    const isDisabled =
      clickable.matches("button:disabled, input:disabled") ||
      clickable.getAttribute("aria-disabled") === "true";

    if (isDisabled) return;

    sendEvent(buildPayload(clickable));
  }

  function init() {
    if (isInitialized || !shouldTrackCurrentPage()) {
      return;
    }

    document.addEventListener("click", handleClick, true);
    isInitialized = true;
  }

  return {
    init,
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  QuickOrderListFeature.init();
  ExternalCustomerIdModal.init();
  SavivaFeature.init();
  MercantoFeature.init();
  LoyaltyProgramFeature.init();
  CheckoutInterception.init();
  SupplierAvailabilityFeature.init();
  LandingPageButtonAnalytics.init();
  HandelspartnerManager.init();

  // Run global token validation
  if (typeof window.ensureMercantoSession === "function") {
    window.ensureMercantoSession();
  }

  // Inject modal-scoped disabled button styles to ensure disabled buttons look visually deactivated
  ensureStyleInjected(
    "modal-disabled-button-styles",
    `.mercanto-auth__modal button:disabled,
     .saviva-auth__modal button:disabled,
     .guest-auth__modal button:disabled,
     #merchant-selection-form button:disabled,
     #saviva-purchaser-selection-form button:disabled {
        opacity: 0.6 !important;
        cursor: not-allowed !important;
        filter: grayscale(30%) !important;
      }`
  );
});

// Handle browser back/forward navigation (bfcache)
window.addEventListener("pageshow", (event) => {
  // Only re-initialize if the page was loaded from cache
  if (event.persisted) {
    console.log("[UFS] Page loaded from bfcache, re-initializing features");
    QuickOrderListFeature.init();
    SavivaFeature.init();
    MercantoFeature.init();
    LoyaltyProgramFeature.init();
    CheckoutInterception.init();
    SupplierAvailabilityFeature.init();
    LandingPageButtonAnalytics.init();
    HandelspartnerManager.init();

    // Run global token validation
    if (typeof window.ensureMercantoSession === "function") {
      window.ensureMercantoSession();
    }

    // Ensure modal disabled styles are present after re-initialization
    ensureStyleInjected(
      "modal-disabled-button-styles",
      `.mercanto-auth__modal button:disabled,
       .saviva-auth__modal button:disabled,
       .guest-auth__modal button:disabled,
       #merchant-selection-form button:disabled,
       #saviva-purchaser-selection-form button:disabled {
          opacity: 0.6 !important;
          cursor: not-allowed !important;
          filter: grayscale(30%) !important;
        }`
    );
  }
});

async function fetchCartLineItems() {
  const response = await fetch("/cart.js");
  if (!response.ok) {
    throw new Error("Unable to load cart");
  }

  const cart = await response.json();
  return cart.items.map((item) => ({
    articleNumber: item.variant_id.toString(),
    quantity: item.quantity,
  }));
}

function submitNativeCheckout(button) {
  const form = button.closest("form");
  if (form) {
    form.submit();
    return;
  }

  window.location.href = window.routes.cart_url;
}

function ensureStyleInjected(id, styles) {
  if (document.getElementById(id)) {
    return;
  }

  const style = document.createElement("style");
  style.id = id;
  style.textContent = styles;
  document.head.appendChild(style);
}
